import * as Tickets from "repository/TicketRepository";

export const createMapReportTicket = async (mapTitle, projectId, message) => {
    return Tickets.createTicket(
        "technical",
        "PRIORITY_LOW",
        `Map Issue Report: ${mapTitle}`,
        message,
        projectId,
        null
    )
}